import { render, staticRenderFns } from "./pcard.vue?vue&type=template&id=01da1323&scoped=true&"
import script from "./pcard.vue?vue&type=script&lang=js&"
export * from "./pcard.vue?vue&type=script&lang=js&"
import style0 from "./pcard.vue?vue&type=style&index=0&id=01da1323&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da1323",
  null
  
)

export default component.exports